import React, { Component, Fragment } from "react";
import NavBar from "../molecules/NavBar";
import HeaderProjects from "../molecules/HeaderProjects";
import HeaderEmpresas from "../molecules/HeaderEmpresas";
import HeaderContactos from "../molecules/HeaderContactos";
import HeaderContacto from "../molecules/HeaderContacto";
import ListaProyectos from "../atoms/proyectos/ListaProyectos";

import CrearProyectoModal from "../atoms/proyectos/CrearProyectoModal";
import Modal from "react-responsive-modal";

import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";

import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Redirect } from "react-router-dom";

class Dashboard extends Component {
  state = {
    open: false
  };

  componenentDidMount() {
    console.log(this.props);
  }

  componentWillMount() {
    console.log(this.props);
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  render() {
    // console.log(this.props);
    const { projects, auth, profile } = this.props;

    const { open } = this.state;

    let proyectosUsuario =
      projects && projects.filter(project => project.authorId === auth.uid);
    // console.log(proyectosUsuario);

    if (auth.uid && !profile.cargo) return <Redirect to="/completarPerfil" />;
    else if (!auth.uid) return <Redirect to="/entrar" />;
    else if (
      !proyectosUsuario ||
      proyectosUsuario === undefined ||
      proyectosUsuario.length === 0
    )
      return (
        <Fragment>
          <NavBar />
          <div
            className="container ptb  lighten-5 rounded p-5 center-align"
            style={{ marginTop: "20em" }}
          >
            <p className="blue-text">
              No tienes proyectos, por favor, añade uno para continuar.
            </p>
            <button
              className="btn btn-large btn-block blue accent-4"
              onClick={this.onOpenModal}
            >
              CREAR PROYECTO
            </button>
            <Modal open={open} onClose={this.onCloseModal} center>
              <CrearProyectoModal onCloseModal={this.onCloseModal} />
            </Modal>
          </div>
        </Fragment>
      );
    else if (
      proyectosUsuario &&
      !(proyectosUsuario === undefined) &&
      !(proyectosUsuario.length === 0)
    )
      return (
        <Fragment>
          <NavBar />
          <Grid
            container
            spacing={0}
            justify="flex-start"
            className="mainContainer"
          >
            <Grid item sm className="borderRight">
              <HeaderProjects />
              <List style={{ margin: "0", padding: "0" }}>
                <ListaProyectos proyectosUsuario={proyectosUsuario} />
              </List>
            </Grid>
            <Grid item sm className="borderRight">
              <HeaderEmpresas />
              <List />
            </Grid>
            <Grid item sm className="borderRight">
              <HeaderContactos />
              <List />
            </Grid>
            <Grid item sm>
              <HeaderContacto />
              <List />
            </Grid>
          </Grid>
        </Fragment>
      );

    return <div>... Loading</div>;
  }
}

const mapStateToProps = state => {
  // console.log(state);
  return {
    projects: state.firestore.ordered.projects,
    auth: state.firebase.auth,
    notifications: state.firestore.ordered.notifications,
    profile: state.firebase.profile
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    { collection: "projects", orderBy: ["createdAt", "asc"] },
    { collection: "notifications", limit: 6, orderBy: ["time", "desc"] },
    { collection: "users" }
  ])
)(Dashboard);
